<template>
    <AppHeader fixed>
        <SidebarToggler class="d-lg-none" display="md" mobile />
        <b-link class="navbar-brand" to="#">
            <img class="navbar-brand-full" src="/logo.png" height="25" alt="Logo">
            <img class="navbar-brand-minimized" src="/logo.png" width="30" height="30" alt="Logo">
        </b-link>
        <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
        <b-navbar-nav class="ml-auto">
            <b-nav-item class="header-user-info">
                <div class="header-user-data">
                    <h6 class="header-user-name">
                        {{ fullName }}
                    </h6>
                    <div class="d-flex align-items-center justify-content-end">
                        <span class="header-user-position">{{ roleName }}</span>
                    </div>
                </div>
			</b-nav-item>
            <DefaultHeaderDropdownAccnt class="mr-2" @change-password="didChangePassword" @change-passcode="didChangePasscode" @logout="didLogout" />
        </b-navbar-nav>
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
    name: 'DefaultHeader',
    components: {
        AsideToggler,
        AppHeader,
        DefaultHeaderDropdownAccnt,
        SidebarToggler
    },
    props: {
        fullName: { type: String, required: true },
        roleName: { type: String, required: true }
    },
    data() {
        return {
        }
    },
    methods: {

        didChangePassword() {
            this.$emit("change-password")
        },

        didChangePasscode() {
            this.$emit("change-passcode")
        },

        didLogout() {
            this.$emit("logout")
        }

    }
}
</script>
